const mensdata = {
    mensproductItems : [{
        id: "8",
        name: "Hoodie",
        description:  "Designer Black Hoodie ",
        price : "400",
        Image : "https://img.shopstyle-cdn.com/sim/20/dc/20dcf0bda1c171863bf8b7144f1bf481_best/asos-design-oversized-hoodie-in-black-with-photographic-statue-back-print-black-black.jpg",
        instock : 5
    
    } ,
    {
        id: "9",
        name: "Shirt",
        description:  "White Baggy-Shirt",
        price : "700",
        Image : "https://lp2.hm.com/hmgoepprod?set=format%5Bwebp%5D%2Cquality%5B79%5D%2Csource%5B%2Fc8%2Ff1%2Fc8f1239b34f50879c8a5a3d704cbaf108892309b.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5B%5D%2Ctype%5BLOOKBOOK%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url%5Bfile%3A%2Fproduct%2Fmain%5D",
        instock : 4
    } ,
    {
        id: "10",
        name: "Pant",
        description:  "Grey Pant",
        price : "600",
        Image : "https://rukminim1.flixcart.com/image/832/832/xif0q/trouser/8/i/c/30-4way-polo-white-luxury-original-imagcuegygpbchh6-bb.jpeg?q=70",
        instock : 5
    } ,
    {
        id: "11",
        name: "T-shirt",
        description:  "Green T-shirt",
        price : "300",
        Image : "https://assets.bonkerscorner.com/uploads/2021/12/22134511/686.jpg",
        instock : 4
    } ,
    {
        id: "12",
        name: "Full-Sleave",
        description:  "Premium Clothing",
        price : "5000",
        Image : "https://lp2.hm.com/hmgoepprod?set=format%5Bwebp%5D%2Cquality%5B79%5D%2Csource%5B%2F69%2Fd4%2F69d42b5cb66cc7c446bbd05d9fea1d192f666aff.jpg%5D%2Corigin%5Bdam%5D%2Ccategory%5B%5D%2Ctype%5BLOOKBOOK%5D%2Cres%5Bm%5D%2Chmver%5B1%5D&call=url%5Bfile%3A%2Fproduct%2Fmain%5D",
        instock : 2
    } ,
    {
        id: "13",
        name: "Nike",
        description:  "Airforce",
        price : "150",
        Image : "https://static.nike.com/a/images/t_PDP_1280_v1/f_auto,q_auto:eco/ebad848a-13b1-46d5-a85e-49b4b6a4953c/air-force-1-le-older-shoe-TDGHCN.png",
        instock : 3
    } ,
    {
        id: "14",
        name: "AirMax",
        description:  "Training Shoe",
        price : "250",
        Image : "https://static.nike.com/a/images/f_auto,cs_srgb/w_1536,c_limit/yzekvnsnzitvg1viujqc/nike-air-max-air-max-day.jpg",
        instock : 2
    } ]}
    

    

export default mensdata;